import React from 'react';
import { Stepper } from '../stepper/Stepper';
import { Step } from '../stepper/Step/Step';
import { StepIndicator } from '../stepper/StepIndicator/StepIndicator';
import { Icon } from '../icon';
import { Button } from '../button/Button';
import {
	OnboardingWizardRoot,
	OnboardingWizardSidebar,
	OnboardingWizardContent,
	OnboardingWizardContentHeader,
	OnboardingWizardContentBody,
} from './OnboardingWizard.styled';

export interface OnboardingWizardStep {
	label: string;
	title: string;
	description: string;
	ctaLabel: string;
	onCtaClick?: () => void;
}

export interface OnboardingWizardProps {
	steps: OnboardingWizardStep[];
	activeStep?: number;
	completedTitle?: string;
	completedMessage?: string;
	closeLabel?: string;
	onClose?: () => void;
}

const OnboardingWizard = React.forwardRef<HTMLDivElement, OnboardingWizardProps>(
	function OnboardingWizard({
		steps,
		activeStep = 0,
		onClose,
		completedMessage,
		completedTitle,
		closeLabel = 'Close',
	}, ref) {
		const isCompleted = activeStep >= steps.length;
		const activeStepData = steps[Math.min(activeStep, steps.length - 1)];

		return (
			<OnboardingWizardRoot ref={ref}>
				<OnboardingWizardSidebar>
					<Stepper activeStep={isCompleted ? steps.length : activeStep} orientation="vertical">
						{steps.map((step, index) => (
							<Step
								key={step.label}
								index={index}
								last={index === steps.length - 1}
								indicator={
									<StepIndicator>
										{(!isCompleted && activeStep <= index) ? index + 1 : <Icon icon="checkmark" />}
									</StepIndicator>
								}
							>
								{step.label}
							</Step>
						))}
					</Stepper>
				</OnboardingWizardSidebar>

				{isCompleted ? (
					<OnboardingWizardContent>
						<OnboardingWizardContentHeader>{completedTitle}</OnboardingWizardContentHeader>
						<OnboardingWizardContentBody>
							<p>{completedMessage}</p>
							<Button
								label={closeLabel}
								variant="secondary"
								onClick={onClose}
							/>
						</OnboardingWizardContentBody>
					</OnboardingWizardContent>
				) : (
					<OnboardingWizardContent>
						<OnboardingWizardContentHeader>
							{activeStepData.title}
						</OnboardingWizardContentHeader>
						<OnboardingWizardContentBody>
							<p>{activeStepData.description}</p>
							<Button
								label={activeStepData.ctaLabel}
								icon="arrow-right"
								iconPosition="right"
								variant="secondary"
								onClick={activeStepData.onCtaClick}
							/>
						</OnboardingWizardContentBody>
					</OnboardingWizardContent>
				)}
			</OnboardingWizardRoot>
		);
	}
);

export { OnboardingWizard };
